(() => {
  document.querySelectorAll('[data-artist-index]').forEach((index) => {
    const rows = Array.from(index.querySelectorAll('[data-artist-row]'));
    const preview = index.querySelector('[data-artist-index-preview]');
    const previewImage = preview?.querySelector('img');
    const hoverMedia = matchMedia('(min-width:751px) and (hover:hover) and (pointer:fine)');
    let activeRow = null;
    let lastPointerX = innerWidth / 2;
    let lastPointerY = innerHeight / 2;
    let previewFrame = 0;
    const hidePreview = () => {
      activeRow = null;
      preview?.classList.remove('is-active');
    };
    const positionPreview = (row, pointerX = lastPointerX, pointerY = lastPointerY) => {
      if (!row || !preview || !hoverMedia.matches) return hidePreview();
      const rect = row.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return hidePreview();
      const width = Math.min(190, Math.max(120, innerWidth * .13));
      const height = width * 1.25;
      const gap = 18;
      let x = pointerX + gap;
      if (x + width > innerWidth - 20) x = pointerX - width - gap;
      x = Math.max(20, Math.min(x, innerWidth - width - 20));
      const y = Math.max(20, Math.min(pointerY - height / 2, innerHeight - height - 20));
      preview.style.setProperty('--artist-preview-x', x + 'px');
      preview.style.setProperty('--artist-preview-y', y + 'px');
    };
    const showPreview = (row, pointerX, pointerY) => {
      const source = row.dataset.artistPreviewSrc;
      if (!source || !previewImage || !hoverMedia.matches) return hidePreview();
      activeRow = row;
      previewImage.src = source;
      positionPreview(row, pointerX, pointerY);
      preview.classList.add('is-active');
    };
    rows.forEach((row) => {
      row.addEventListener('pointerenter', (event) => {
        lastPointerX = event.clientX;
        lastPointerY = event.clientY;
        showPreview(row, lastPointerX, lastPointerY);
      });
      row.addEventListener('pointermove', (event) => {
        lastPointerX = event.clientX;
        lastPointerY = event.clientY;
        if (activeRow === row) positionPreview(row, lastPointerX, lastPointerY);
      });
      row.addEventListener('pointerleave', hidePreview);
      row.addEventListener('focus', () => {
        const rect = row.getBoundingClientRect();
        lastPointerX = rect.left + rect.width * .65;
        lastPointerY = rect.top + rect.height / 2;
        showPreview(row, lastPointerX, lastPointerY);
      });
      row.addEventListener('blur', hidePreview);
    });
    const syncPreview = () => {
      if (!activeRow) return;
      cancelAnimationFrame(previewFrame);
      previewFrame = requestAnimationFrame(() => positionPreview(activeRow, lastPointerX, lastPointerY));
    };
    addEventListener('scroll', syncPreview, { passive: true });
    addEventListener('resize', syncPreview, { passive: true });
    addEventListener('blur', hidePreview);
  });
})();
